import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { gradients } from "./theme/theme";

const courses = [
  {
    id: "1",
    title: "React Native Crash Course",
    thumbnail: "https://img.youtube.com/vi/0-S5a0eXPoc/maxresdefault.jpg",
    progress: 40,
  },
  {
    id: "2",
    title: "SQL for Beginners",
    thumbnail: "https://img.youtube.com/vi/HXV3zeQKqGY/maxresdefault.jpg",
    progress: 70,
  },
];

const MyCourses = () => {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <h1>My Courses</h1>
      <CourseGrid>
        {courses.map((course) => (
          <CourseCard
            key={course.id}
            onClick={() => navigate(`/mycourses/courses/${course.id}`)}
          >
            <Thumbnail src={course.thumbnail} />
            <h3>{course.title}</h3>
            <ProgressBar>
              <ProgressFill style={{ width: `${course.progress}%` }} />
            </ProgressBar>
            <small>{course.progress}% completed</small>
          </CourseCard>
        ))}
      </CourseGrid>
    </Wrapper>
  );
};

export default MyCourses;

const Wrapper = styled.div`
  padding: 2rem;
  min-height: 100vh;
  background: ${gradients.heroBackground};
  color: white;
`;

const CourseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
`;

const CourseCard = styled.div`
  background: #1e293b;
  border-radius: 12px;
  padding: 1rem;
  cursor: pointer;
  transition: transform 0.3s;
  &:hover {
    transform: translateY(-6px);
  }
`;

const Thumbnail = styled.img`
  width: 100%;
  height: 150px;
  border-radius: 10px;
  object-fit: cover;
`;

const ProgressBar = styled.div`
  background: #334155;
  border-radius: 10px;
  margin: 0.5rem 0;
  height: 8px;
  width: 100%;
`;

const ProgressFill = styled.div`
  background: #38bdf8;
  height: 100%;
  border-radius: 10px;
`;
